var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            React.createElement("path", { d: "M23.689 17c.61 0 1.112.487 1.18 1.115l.009.147v5.213h4.433c.61 0 1.112.488 1.181 1.116l.008.147c0 .647-.459 1.18-1.05 1.254L29.31 26h-5.622c-.61 0-1.112-.487-1.181-1.115l-.008-.147v-6.476c0-.697.532-1.262 1.189-1.262z", fill: "currentColor", fillRule: "nonzero" }),
            React.createElement("circle", { stroke: "currentColor", strokeWidth: 2, cx: 24, cy: 24, r: 11 }))));
});
